// @flow

import qs from 'qs';
import cuid from 'cuid';
import { removeToken } from 'helpers/token';
import { setPrevPath } from 'helpers/prevPath';
import { authServerUrl, clientId, authRedirectUrl } from 'core/config/env';

const redirectToAuth = (state: string = cuid()): void => {
  const params = qs.stringify({
    state,
    client_id: clientId,
    redirect_uri: authRedirectUrl,
    response_type: 'token'
  });

  removeToken();
  setPrevPath(window.location.pathname);

  window.location.href = `${authServerUrl}?${params}`;
};

export default redirectToAuth;
